import { render } from "./text-modal-component.vue?vue&type=template&id=0ab80a08"
import script from "./text-modal-component.vue?vue&type=script&lang=js"
export * from "./text-modal-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__